import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import HeroPolitica from '../Components/HeroPolitica';
import Politica from '../Components/Politica';

const politica = () => {
    return (
        <div className="h-full overflow-x-hidden">
            <Header />
            <HeroPolitica />
            <Politica />
            <Footer />
        </div>
    )
}

export default politica